import { Button as AIMEButton } from "tot-loft-component-library";
import * as PRTNR from "./prtnr";
import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  sendMemberEmail,
  updateMembersItem,
} from "./redux/slices/MembersThunks";
import { isValidEmail, isValidUKPhone } from "./utils/func";

export default function ModalAdmineditmember({
  onClose,
  data,
  setData,
  setOldData,
  oldData,
  openSuccessModal,
}) {
  const dispatch = useDispatch();
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const handleEmailSend = async () => {
    const resdata = {
      id: data?._id,
    };
    await dispatch(sendMemberEmail(resdata));
    onClose();
    openSuccessModal();
  };

  const handler = async () => {
    setHasSubmitted(true);
    data.email_address = data.email_address?.trim().toLowerCase();
    const isIndividual = data.member_type === "Individual" ? true : false;  

    const missingRequiredFields =
      !data.first_name ||
      !data.last_name ||
      !data.email_address ||
      !data.company_no ||
      !data.tax_identification_no ||
      !isValidEmail(data.email_address) ||
      !data.phone_number ||
      !isValidUKPhone(data.phone_number) ||
      (!isIndividual && (!data.company_name || !data.company_address)) ||
      (!isIndividual &&
        data.is_uk_registered &&
        !data.unique_taxpayer_reference_utr);

    if (missingRequiredFields) {
      return;
    }

    try {
      const newData = { ...data };
      const res = await dispatch(updateMembersItem(data));
      if (res?.payload?.account_id) newData.account_id = res.payload.account_id;
      setOldData(newData);
      setHasSubmitted(false);
      onClose();
    } catch (e) {
      console.log(e, "error");
    }
  };

  return (
    <Wrapper>
      <Frame58>
        <Frame1391>
          <UpdateHistory>Edit Details</UpdateHistory>
          <InputTogether>
            <PRTNR.Input
              label={"First Name"}
              value={data.first_name}
              onChange={(e) => {
                setData({ ...data, first_name: e.target.value });
              }}
              required
              error={hasSubmitted && !data.first_name}
              errorMessage={"First name is required"}
            />
            <PRTNR.Input
              label={"Last Name"}
              value={data.last_name}
              onChange={(e) => {
                setData({ ...data, last_name: e.target.value });
              }}
              required
              error={hasSubmitted && !data.last_name}
              errorMessage={"Last name is required"}
            />
          </InputTogether>
          <PRTNR.Input
            label={"Email Address"}
            value={data.email_address}
            onChange={(e) => {
              setData({ ...data, email_address: e.target.value });
            }}
            required
            error={
              hasSubmitted &&
              (!data.email_address || !isValidEmail(data.email_address))
            }
            errorMessage={
              !data.email_address
                ? "Email address is required"
                : !isValidEmail(data.email_address)
                ? "Please enter a valid email address (e.g., user@example.com)"
                : ""
            }
            button={
              !data?.account_id?.isEmailVerified && (
                <SendButton type="button" onClick={handleEmailSend}>
                  Send Confirmation
                </SendButton>
              )
            }
          />
          <PRTNR.Input
            label={"Phone"}
            value={data.phone_number}
            onChange={(e) => {
              setData({ ...data, phone_number: e.target.value });
            }}
            required
            error={
              hasSubmitted &&
              (!data.phone_number || !isValidUKPhone(data.phone_number))
            }
            errorMessage={
              !data.phone_number
                ? "Phone number is required"
                : !isValidUKPhone(data.phone_number)
                ? "Please enter a valid UK phone number (e.g., 07123456789 or +44 7123456789)"
                : ""
            }
          />
          {data?.member_type == "Enterprise" && (
            <>
              <PRTNR.Input
                label={"Company Name"}
                value={data.company_name}
                onChange={(e) => {
                  setData({ ...data, company_name: e.target.value });
                }}
                required
                error={hasSubmitted && !data.company_name}
                errorMessage={"Company name is required"}
              />
              <PRTNR.Input
                label={"Company Website"}
                value={data.company_website_url}
                onChange={(e) => {
                  setData({ ...data, company_website_url: e.target.value });
                }}
              />
              <PRTNR.Input
                label={"Company Address"}
                value={data.company_address}
                onChange={(e) => {
                  setData({ ...data, company_address: e.target.value });
                }}
                required
                error={hasSubmitted && !data.company_address}
                errorMessage={"Company address is required"}
              />
            </>
          )}
          <InputTogether>
            <PRTNR.Input
              label={"Job Title"}
              value={data.job_title}
              onChange={(e) => {
                setData({ ...data, job_title: e.target.value });
              }}
            />
            <PRTNR.Select
              label={"Seniority"}
              value={data.seniority}
              options={[
                { value: "C-level", label: "C-level" },
                { value: "Consultant", label: "Consultant" },
                { value: "Senior Management", label: "Senior Management" },
                { value: "Manager", label: "Manager" },
                { value: "Assistant", label: "Assistant" },
                { value: "Junior Professional", label: "Junior Professional" },
              ]}
              onChange={(e) => {
                setData({ ...data, seniority: e.target.value });
              }}
            />
          </InputTogether>
          <InputTogether>
            <PRTNR.Input
              label={"City"}
              value={data.city}
              onChange={(e) => {
                setData({ ...data, city: e.target.value });
              }}
            />
            <PRTNR.Input
              label={"Country of residence"}
              value={data.country_of_residence}
              onChange={(e) => {
                setData({ ...data, country_of_residence: e.target.value });
              }}
            />
          </InputTogether>
          {data?.member_type == "Enterprise" && (
            <>
              <InputTogether>
                <PRTNR.Input
                  label={"Company no"}
                  value={data.company_no}
                  onChange={(e) => {
                    setData({ ...data, company_no: e.target.value });
                  }}
                  error={hasSubmitted && !data.company_no}
                  errorMessage={"Company no required"}
                />
                <PRTNR.Input
                  label={"VAT Number"}
                  value={data.tax_identification_no}
                  onChange={(e) => {
                    setData({ ...data, tax_identification_no: e.target.value });
                  }}
                  error={hasSubmitted && !data.tax_identification_no}
                  errorMessage={"VAT Number required"}
                />
              </InputTogether>
              <PRTNR.Select
                label="Is your company a UK partnership"
                options={[
                  { value: false, label: "No" },
                  { value: true, label: "Yes" },
                ]}
                value={data.is_uk_registered}
                onChange={(e) => {
                  if (e.target.value == false) {
                    setData({ ...data, unique_taxpayer_reference_utr: "" });
                  }
                  setData({ ...data, is_uk_registered: e.target.value });
                }}
              />
              {data?.is_uk_registered ? (
                <PRTNR.Input
                  label="Unique taxpayer reference (UTR)"
                  value={data.unique_taxpayer_reference_utr}
                  onChange={(e) => {
                    setData({
                      ...data,
                      unique_taxpayer_reference_utr: e.target.value,
                    });
                  }}
                  required
                  error={hasSubmitted && !data.unique_taxpayer_reference_utr}
                  errorMessage={"Please enter a valid 10-digit UTR number"}
                />
              ) : (
                <PRTNR.DisabledInput
                  label="Unique taxpayer reference (UTR)"
                  required
                />
              )}
            </>
          )}
        </Frame1391>
        <Frame1416>
          <AIMEButton
            size="small"
            onClick={() => {
              setData(oldData);
              setHasSubmitted(false);
              onClose();
            }}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
              flex: "none",
              borderRadius: "999px",
              background: "rgb(241, 245, 249)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "center",
              boxSizing: "border-box",
              padding: "16px 32px",
            }}
          >
            <span
              style={{
                color: "rgb(33, 37, 67)",
                textOverflow: "ellipsis",
                fontSize: "16px",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: "600",
                lineHeight: "110%",
                textAlign: "left",
              }}
            >
              Cancel
            </span>
          </AIMEButton>

          <AIMEButton
            size="small"
            onClick={() => {
              handler();
            }}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
              flex: "none",
              gap: "10px",
              borderRadius: "48px",
              width: "240px",
              background: "rgb(97, 98, 197)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "center",
              boxSizing: "border-box",
              padding: "16px 32px",
            }}
          >
            <span
              style={{
                color: "white",
                textOverflow: "ellipsis",
                fontSize: "16px",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: "600",
                lineHeight: "110%",
                textAlign: "left",
              }}
            >
              Save
            </span>
          </AIMEButton>
        </Frame1416>
      </Frame58>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  padding: 40px 24px 24px;
  box-sizing: border-box;
  width: 960px;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const UpdateHistory = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const InputTogether = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
`;

const Frame1416 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const SendButton = styled.button`
  background-color: #5e5df0;
  color: white;
  border: none;
  padding: 0 12px;
  height: 36px;
  font-weight: 600;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: #4b4acb;
  }
`;
